'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';
import { trackPageView } from '@/lib/analytics';

/**
 * Fires a page-view beacon on every route change (mounted once in the root layout,
 * inside AuthProvider so it can attribute logged-in users). Renders nothing.
 */
export default function PageViewTracker() {
  const pathname = usePathname();
  const { user } = useAuth();

  useEffect(() => {
    if (!pathname) return;
    trackPageView(pathname, user?.id ?? null);
    // Only re-fire on path change or login/logout, not on every user-object update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, user?.id]);

  return null;
}
